/* eslint-disable @typescript-eslint/default-param-last */
import { IInterviewPermissionsType } from "@/types/zoomClient.types";
import { UPDATE_PERMISSIONS } from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const interviewPermissionReducer = (
  state = initialState.interviewPermissions,
  action: IInterviewPermissionsType,
) => {
  switch (action.type) {
    case UPDATE_PERMISSIONS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default interviewPermissionReducer;
